import { createFileRoute } from "@tanstack/react-router";

import { SourceControlCallbackPage } from "../components/auth/SourceControlCallbackPage";

export const Route = createFileRoute("/source-control/callback")({
  head: () => ({
    meta: [
      { title: "Repository authorization · Maito" },
      { name: "robots", content: "noindex" },
      { name: "referrer", content: "no-referrer" },
    ],
  }),
  validateSearch: (search: Record<string, unknown>) =>
    ({
      host:
        search.host === "github" || search.host === "gitlab" || search.host === "bitbucket"
          ? search.host
          : undefined,
      status: search.status === "received" ? "received" : "error",
    }) as const,
  component: SourceControlCallbackPage,
});
